import { useContext } from 'react';
import { ListLayoutContext } from 'src/common/contexts/list-layout/provider';
import { ListLayoutContextProps } from 'src/common/contexts/list-layout/types';

export function useListLayout(): ListLayoutContextProps {
    const context = useContext(ListLayoutContext);

    return context;
}
